<template>
  <div class="container">
    <transition>
      <div class="block animated" :style="{top:this.positionY,left:this.positionX,gridArea:'main2'}" @mousedown="move"
           ref="block">
        {{positionX}}
        {{positionY}}
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'test',
    data() {
      return {
        positionX: 0, // 定义方块的两个坐标
        positionY: 0
      }
    },
    methods: {
      move(e) {
        console.log(e, '11')
        const oDiv = e.target; // 获取点击的目标元素
        const gDiv = e.path[1]; // 获取点击元素的父级元素

        /* 获取点击时的偏移位置，在这里要注意一下
        **由于我们用的是网格布局,每在一个格子中相对位置都是相对格子来算的，不是相对于父级盒子左上角
        **也就是说当你把方块移动到九个格子中任意一个时，方块的位置都是top：0和left：0
        */

        // 所以这里我们直接取鼠标点击的位置减去点击盒子的偏移位置，也就是0
        const disX = e.clientX;
        const disY = e.clientY;
        document.onmousemove = (e) => {
          // 当拖动时，算出的值就刚好是方块的top和left值
          const left = e.clientX - disX;
          const top = e.clientY - disY;
          this.rangeOfHead1(left, top, oDiv)
          // switch (oDiv.style.gridArea) {
          //   case 'head1 / head1 / head1 / head1':
          //     this.rangeOfHead1(left, top, oDiv);
          //     break; // 实现head1的移动范围
          //   case 'head2 / head2 / head2 / head2':
          //     this.rangeOfHead2(left, top, oDiv);
          //     break; // 实现head2的移动范围
          //   case 'head3 / head3 / head3 / head3':
          //     this.rangeOfHead3(left, top, oDiv);
          //     break; // 实现head3的移动范围
          //   case 'main1 / main1 / main1 / main1':
          //     this.rangeOfMain1(left, top, oDiv);
          //     break; // 实现main1的移动范围
          // }
        };
        document.onmouseup = (e) => {
          // 当鼠标抬起时，我们要做的事
          // 通过点击位置和父级元素的偏移判断方块在哪个区域
          if (e.clientY - gDiv.offsetTop < 100 && e.clientX - gDiv.offsetLeft < 100) {
            // 将方块移动到该区域中
            this.changeBlock('head1', oDiv);
          } else if (e.clientY - gDiv.offsetTop > 100 && e.clientX - gDiv.offsetLeft < 100 && e.clientY - gDiv.offsetTop < 200) {
            this.changeBlock('main1', oDiv);
          } else if (e.clientY - gDiv.offsetTop > 200 && e.clientX - gDiv.offsetLeft < 100) {
            this.changeBlock('footer1', oDiv);
          } else if (e.clientY - gDiv.offsetTop < 100 && e.clientX - gDiv.offsetLeft > 100 && e.clientX - gDiv.offsetLeft < 200) {
            this.changeBlock('head2', oDiv);
          } else if (e.clientY - gDiv.offsetTop < 100 && e.clientX - gDiv.offsetLeft > 200) {
            this.changeBlock('head3', oDiv);
          } else if (e.clientY - gDiv.offsetTop > 100 && e.clientX - gDiv.offsetLeft > 200 && e.clientY - gDiv.offsetTop < 200) {
            this.changeBlock('main3', oDiv);
          } else if (e.clientY - gDiv.offsetTop > 200 && e.clientX - gDiv.offsetLeft > 200) {
            this.changeBlock('footer3', oDiv);
          } else if (e.clientY - gDiv.offsetTop > 200 && e.clientX - gDiv.offsetLeft > 100 && e.clientX - gDiv.offsetLeft < 200) {
            this.changeBlock('footer2', oDiv);
          } else {
            this.changeBlock('main2', oDiv);
          }
          document.onmousemove = null; // 需要把事件监听取消
          document.onmousedown = null; // 需要把事件监听取消

          // 当然，不能忘记我们的动画hhh
          oDiv.className = 'block animated wobble';
          // eslint-disable-next-line no-unused-vars
          const removeClass = setTimeout(() => {
            oDiv.className = 'block animated';
          }, 500);
        };
      },
      rangeOfHead1(x, y, oDiv) { // 判断head1格子中的可以移动范围
        // if (x >= 200) {
        //   x = 200;
        // } else if (x <= 0) {
        //   x = 0;
        // }
        // if (y >= 200) {
        //   y = 200;
        // } else if (y <= 0) {
        //   y = 0;
        // }
        oDiv.style.left = x + 'px';
        oDiv.style.top = y + 'px';
        this.positionX = x;
        this.positionY = y;
      },
      rangeOfHead2(x, y, oDiv) { // 判断head2格子中的可以移动范围
        if (x >= 100) {
          x = 100;
        } else if (x <= -100) {
          x = -100;
        }
        if (y >= 200) {
          y = 200;
        } else if (y <= 0) {
          y = 0;
        }
        oDiv.style.left = x + 'px';
        oDiv.style.top = y + 'px';

        this.positionX = x;
        this.positionY = y;
      },
      rangeOfHead3(x, y, oDiv) { // 判断head3格子中的可以移动范围
        if (x >= 0) {
          x = 0;
        } else if (x <= -200) {
          x = -200;
        }
        if (y >= 200) {
          y = 200;
        } else if (y <= 0) {
          y = 0;
        }
        oDiv.style.left = x + 'px';
        oDiv.style.top = y + 'px';

        this.positionX = x;
        this.positionY = y;
      },
      changeBlock(blockName, oDiv) { // 将方块移入到对应的区域中
        this.positionX = 0;
        this.positionY = 0;
        oDiv.style.gridArea = blockName;
      }
    }
  }
</script>

<style scoped lang="scss">
  .container {
    position: relative; /*实现定位，使得滑块定位相对于此*/
    display: grid; /*定义网格布局*/
    width: 300px;
    height: 300px;
    grid-template-columns: 100px 100px 100px; /*实现九宫格，行列各三*/
    grid-template-rows: 100px 100px 100px;
    grid-template-areas: "head1 head2 head3" /*定义个格子的名称，方便计算*/
    "main1 main2 main3" "footer1 footer2 footer3";
    border: 1px solid #000;
    margin: 0 auto;
  }

  .block {
    position: absolute; /*相对于container定位*/
    width: 100px;
    height: 100px;
    display: flex; /*flex布局，使得文字在中央*/
    justify-content: center;
    justify-items: center;
    align-items: center;
    align-content: center;
    user-select: none; /*用户不可选定文字*/
    background: olivedrab;
    border: 1px solid #000
  }
</style>
